import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const indicatorImporterSelectors = importerSelectors(
  'indicator.importer',
);

export default indicatorImporterSelectors;
